/**
 * @file 默认语言和法币单位
 */
import { isClient } from '@vueuse/shared';
import { useCommonStore } from '@/store/common';
import { useConfigStore } from '@/store/config';
import { useActivityStore } from '@/store/activity';
import { useLayoutStore } from '@/store/layout';
import { setLang, supportLang, getLanguageISO, getRouteLangPath, getOriginPath } from '@/lang/i18n';
import { defaultLang, defaultLegalFlag } from '@/config/setup';
import { supportLanguagesMap } from '@/config/site';

export default () => {
  const route = useRoute();
  const commonStore = useCommonStore();
  const configStore = useConfigStore();
  const activityStore = useActivityStore();
  const layoutStore = useLayoutStore();

  const langPath = route.path.split('/')[1];
  const langPathISO = supportLang(langPath) ? getLanguageISO(langPath) : defaultLang;

  /**
   * 设置页面语言
   *
   * @param languages 管理后台配置数据
   */
  const setDefaultLang = async(languages: Array<any>) => {
    const [routeLangItem] = languages.filter((item: any) => item.language === langPathISO.toLowerCase());
    const lang = routeLangItem?.language || languages[0].language;
    let activeLang = `${lang.split('-')[0]}-${lang.split('-')[1].toUpperCase()}`;
    if (isClient) {
      const userChangeCache = sessionStorage.getItem('user-change-locale');

      if (userChangeCache?.includes('force')) {
        const forceLang = userChangeCache.replace('force-', '');
        sessionStorage.setItem('user-change-locale', userChangeCache);
        const { path } = route.matched[0];
        const routeLang = getRouteLangPath(forceLang);
        const replacePath = `${path.replace(activeLang, routeLang)}${window.location.search}`;

        history.replaceState(null, '',  replacePath);
        activeLang = forceLang;

        // 阿拉伯语、波斯语等从右向左页面兼容
        const langConfig = supportLanguagesMap[activeLang];
        if (langConfig && langConfig.direction) {
          document.documentElement.setAttribute('dir', langConfig.direction);
          layoutStore.direction = langConfig.direction;
        }
      }

      setLang(activeLang, activeLang !== langPathISO);
      commonStore.lang = activeLang;
      localStorage.setItem('lang', activeLang);
    }
  };

  if (getOriginPath(route.path).includes('/affiliates/exclusive-activities')) {
    // watch([() => configStore.supportLanguages, () => activityStore.exclusiveActivityRes], ([languages, exclusiveActivityRes]) => {
    //   if (languages.length && Object.keys(exclusiveActivityRes).length) {
    //     setDefaultLang(languages);
    //   }
    // }, { immediate: true });
    watchEffect(() => {
      if (configStore.supportLanguages.length && Object.keys(activityStore.exclusiveActivityRes).length) {
        setDefaultLang(configStore.supportLanguages);
      }
    }, { immediate: true });
  } else {
    watch(() => configStore.supportLanguages, languages => {
      if (languages.length) {
        setDefaultLang(languages);
      }
    }, { immediate: true });
  }

  watch(() => configStore.supportLegalCurrency, legalCurrency => {
    // 法币默认值
    if (legalCurrency.length) {
      const localeCurreny = defaultLegalFlag();
      const [localeCurrenyItem] = legalCurrency.filter((item: any) => item.currency === localeCurreny);
      const currency = localeCurrenyItem?.currency || legalCurrency[0].currency;
      commonStore.suffix = currency;
      commonStore.prefix = localeCurrenyItem?.currencyLabel || legalCurrency[0].currencyLabel;
      isClient && localStorage.setItem('legal_flag', currency);
    }
  }, { immediate: true });
};
